import React from "react";
import BannerPerson from "../../../assets/Images/BannerPerson.png";
import { Stack, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import "../../../App.css";

const MainBanner = () => {
  if (isMobile) {
    return (
      <div
        style={{
          width: "100%",
          height: "300px",
          backgroundColor: "rgba(255, 109, 28, 0.4)",
        }}
      >
        <Stack
          justifyContent="center"
          alignItems="center"
          style={{ width: "90%", margin: "auto", height: "100%" }}
        >
          <div style={{ width: "100%" }}>
            <Typography
              variant="h3"
              component="h1"
              color="black"
              style={{
                fontWeight: "700",
                fontSize: "20px",
                lineHeight: "29px",
                textAlign: "center",
              }}
            >
              Get your job done in better way!
            </Typography>
            <Typography
              variant="subtitle1"
              color="black"
              style={{ textAlign: "center" }}
            >
              Post your request by filling simple requirement and get quotes
              from experts within few minutes.
            </Typography>
            {/* <Stack
              direction="row"
              spacing={3}
              alignItem="center"
              justifyContent="center"
              className="mt-6"
            >
              <Link to="/create-request">
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{ textTransform: "capitalize" }}
                >
                  Post Request
                </Button>
              </Link>
              <Button
                variant="outlined"
                size="small"
                style={{
                  textTransform: "capitalize",
                  fontWeight: "500",
                  fontSize: "16px",
                  lineHeight: "24px",
                  color: "rgba(10, 100, 188, 1)",
                }}
              >
                Become Partner
              </Button>
            </Stack> */}
          </div>
        </Stack>
      </div>
    );
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "400px",
          backgroundColor: "rgba(255, 109, 28, 0.4)",
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          style={{ width: "90%", margin: "auto" }}
        >
          <div style={{ width: "50%" }}>
            <Typography
              variant="h3"
              component="h1"
              color="black"
              style={{
                fontWeight: "700",
                fontSize: "48px",
                lineHeight: "56px",
              }}
            >
              Get your job done in <br /> better way!
            </Typography>
            <Typography variant="subtitle1" color="black">
              Post your request by filling simple requirement and get quotes{" "}
              <br /> from experts within few minutes.
            </Typography>
            <Stack
              direction="row"
              spacing={3}
              alignItem="center"
              className="mt-6"
            >
              <Link to="/create-request">
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{ textTransform: "capitalize" }}
                >
                  Post Request
                </Button>
              </Link>
              <Button
                variant="outlined"
                size="small"
                style={{
                  textTransform: "capitalize",
                  fontWeight: "500",
                  fontSize: "16px",
                  lineHeight: "24px",
                  color: "rgba(10, 100, 188, 1)",
                }}
              >
                Become Partner
              </Button>
            </Stack>
          </div>
          <div style={{ width: "30%" }}>
            <img src={BannerPerson} alt="Banner Person" />
          </div>
        </Stack>
      </div>
    );
  }
};

export default MainBanner;
